import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowsRotate, faChartSimple, faEllipsisV, faPenToSquare, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {
  deleteRespondent, reopenRespondent, sendRespondentEmail,
} from '../../../../bridge';
import { logError } from '../../../../helpers/logger';
import { __ } from '../../../../helpers/translations';
import ChangeEmailModal from '../modals/ChangeEmailModal';

function RespondentCardDropDown({
  surveyId, onChanged, showPopup, setShowPopup, respondentId, status, surveyStatus, email,
}) {
  const completed = status === 'completed';
  const surveyEnded = surveyStatus === 'ended';
  const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);

  const handleToggleClick = (e) => {
    e.stopPropagation();
    setShowPopup(!showPopup);
  };

  const onClickViewReport = async () => {
    setShowPopup(false);
    window.open(`/report/${respondentId}`, '_blank', 'noreferrer');
  };

  const onClickDelete = async () => {
    setShowPopup(false);
    try {
      const { error } = await deleteRespondent(surveyId, respondentId);
      if (error) {
        logError('respondent_card_drop_down_on_click_delete', error);
      } else {
        onChanged();
      }
      setShowPopup(false);
    } catch (error) {
      logError('respondent_card_drop_down_on_click_delete_catch', error);
    }
  };

  const onClickResend = async () => {
    setShowPopup(false);
    try {
      const { error } = await sendRespondentEmail(respondentId);
      if (error) {
        logError('respondent_card_drop_down_on_click_resend', error);
      } else {
        onChanged();
      }
      setShowPopup(false);
    } catch (error) {
      logError('respondent_card_drop_down_on_click_resend_catch', error);
    }
  };

  const onClickOpenForRetake = async () => {
    if (!completed) {
      return;
    }
    setShowPopup(false);
    try {
      const { error } = await reopenRespondent(respondentId);
      if (error) {
        logError('respondent_card_drop_down_on_click_open_for_retake', error);
      } else {
        onChanged();
      }
      setShowPopup(false);
    } catch (error) {
      logError('respondent_card_drop_down_on_click_open_for_retake_catch', error);
    }
  };

  const onClickChangeEmail = async () => {
    setShowPopup(false);
    setShowChangeEmailModal(true);
  };

  const options = [
    {
      key: 'viewReport',
      icon: faChartSimple,
      caption: __('G161'),
      disabled: !completed && !surveyEnded,
      callback: onClickViewReport,
    },
    {
      key: 'delete',
      icon: faTrashAlt,
      caption: __('G162'),
      disabled: completed,
      callback: onClickDelete,
    },
    {
      key: 'resend',
      icon: faPaperPlane,
      caption: __('G163'),
      disabled: completed || surveyEnded,
      callback: onClickResend,
    },
    {
      key: 'reopen',
      icon: faArrowsRotate,
      caption: __('G164'),
      disabled: !completed || surveyEnded,
      callback: onClickOpenForRetake,
    },
    {
      key: 'changeEmail',
      icon: faPenToSquare,
      caption: __('G165'),
      disabled: false,
      callback: onClickChangeEmail,
    },
  ];

  return (
    <>
      <Dropdown
        show={showPopup}
        onToggle={(isOpen) => setShowPopup(isOpen)}
      >
        <FontAwesomeIcon
          icon={faEllipsisV}
          onClick={handleToggleClick}
          className="p-1 cursor-pointer"
        />
        <Dropdown.Menu className="p-0" style={{ marginLeft: '-140px' }}>
          {options.map((option) => (
            <Dropdown.Item
              key={option.key}
              onClick={(e) => {
                e.stopPropagation();
                if (option.disabled) {
                  return;
                }
                option.callback(e);
              }}
              className="py-1 px-2 m-0"
              disabled={option.disabled}
              style={option.disabled
                ? { opacity: 0.4 }
                : { opacity: 1 }}
            >
              <FontAwesomeIcon icon={option.icon} className="me-2" />
              {option.caption}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      {showChangeEmailModal && (
      <ChangeEmailModal
        email={email}
        onChanged={async () => {
          await onChanged();
          setShowChangeEmailModal(false);
        }}
        onCancel={() => setShowChangeEmailModal(false)}
        respondentId={respondentId}
      />
      )}
    </>
  );
}

RespondentCardDropDown.propTypes = {
  surveyId: PropTypes.string,
  onChanged: PropTypes.func,
  showPopup: PropTypes.bool,
  setShowPopup: PropTypes.func,
  respondentId: PropTypes.string,
  status: PropTypes.string,
  surveyStatus: PropTypes.string,
  email: PropTypes.string,
};

export default RespondentCardDropDown;
